<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="field-value">{{ formattedValue }}</div>
  </div>
</template>

<script>
import EquivalentCourseGroupsService from '@/services/equivalentCourseGroups'

export default {
  props: {
    value: {
      type: [String, Array],
      default: '',
    },
    question: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      groups: {},
    }
  },
  computed: {
    formattedValue() {
      const ids = Array.isArray(this.value) ? this.value : [this.value]
      if (!ids.length) return this.emptyValuePlaceholder
      return ids
        .map((id) => this.getEquivalentCourseGroupName(this.groups[id]) || id)
        .join(', ')
    },
    emptyValuePlaceholder() {
      return (
        this.question?.config?.emptyValuePlaceholder ||
        this.question?.config?.default?.value ||
        '-'
      )
    },
  },
  async mounted() {
    const ids = Array.isArray(this.value) ? this.value.join(',') : this.value
    const api = new EquivalentCourseGroupsService(this.$axios, this.$store)

    if (ids) {
      this.groups = await api.getEquivalentCourseGroups({ list: ids })
    }
  },
  methods: {
    getEquivalentCourseGroupName(group) {
      if (!group || !this.question.config?.showDescription) return undefined
      const description = group.displayName || group.description || ''
      const code = group.code
      const doesDescriptionStartsWithCode = description.startsWith(code)
      return doesDescriptionStartsWithCode
        ? description
        : `${code} - ${description}`
    },
  },
}
</script>
